module.exports = __webpack_public_path__ + "assets/img/ic-intro-gift.4e9b144d.png";